export const environment = {
    production: false,
    key: "iXXC2g8nElRX3OcebXrDxMfchWKeHpE806ueRzfwhWxxhkRaix63HLrX8KaHvsEY",
    apiUrl: 'https://api-aws-practice.bicedu.com/api',
    release_version: "v3.0.3",
    copyright: "Copyright © 2012 – 2026. Best In Class Education",
    env_name: "AWS Practice"
};
